import React from 'react'
import Header from '../components/Header'
import BlogCard from '../components/BlogCard'
import Post from './Post'
import Footer from '../components/Footer'


export default function Home() {
  return (
    <>
      <Header />
      <BlogCard />
      <Post />
      <Footer/>
    </>
  )
}
